export default "__VITE_ASSET__n3bPZJC4__"